import { BubbleAlert } from '@go-client/components/BubbleUI';
import {
  BubbleFormActions,
  BubbleFormFooter,
  BubbleFormHeader,
  FormPageComponentHelpfulProps,
} from '@go-client/components/BubbleUI/BubbleForm';
import { FormGenericContainer } from '@go-client/components/FormGenericContainer';
import { EventTemplateFormikForm } from '@go-client/components/Formik/EventTemplateFormik';
import { FormikProps } from 'formik';
import React from 'react';
import {
  ReservableScheduleFormMode,
  RESERVABLE_SCHEDULE_BREADCRUMBS,
} from '../ReservableSchedulePath';
import { camelToSentenceCase } from '@go-shared/lib/string';
import ReservableExperienceTypeSelector from '@go-client/components/ReservableExperienceTypeSelector';

interface SelectExperienceTypePagePropsBase {
  isBusy: boolean;
  mode: ReservableScheduleFormMode;
  setIsBusy: (isBusy: boolean) => void;
  libraryLocked: boolean;
  eventFormik: FormikProps<EventTemplateFormikForm>;
}

type SelectExperienceTypePageProps = SelectExperienceTypePagePropsBase &
  FormPageComponentHelpfulProps<RESERVABLE_SCHEDULE_BREADCRUMBS>;

export default function SelectExperienceTypePage(props: SelectExperienceTypePageProps) {
  const { experienceType } = props.eventFormik.values.reservables;

  const forwardDisabled = false;

  return (
    <div className="eaf-1">
      <FormGenericContainer
        className="h-screen flex flex-col"
        bodyClassName="flex-grow flex flex-col"
        footer={() => (
          <>
            <BubbleFormFooter
              className="text-slate-dark mr-auto"
              items={[{ label: 'Experience Selected', value: props.eventFormik.values.title }]}
            />
            <BubbleFormActions
              isBusy={props.isBusy}
              forwardTitle={
                props.forwardTitle || `Next: Enter ${camelToSentenceCase(experienceType)}s`
              }
              backTitle={props.backTitle}
              onGoForward={props.onGoForward}
              onGoBack={props.onGoBack}
              forwardDisabled={forwardDisabled}
            />
          </>
        )}
      >
        <BubbleFormHeader<RESERVABLE_SCHEDULE_BREADCRUMBS>
          title={props.title || 'Create Experience'}
          subtitle={props.subtitle || 'Select Experience Type'}
          pageIndex={props.pageIndex ?? 1}
          onClose={props.onClose}
          activeBreadcrumb="experienceType"
          breadcrumbs={props.breadcrumbs}
          onBreadcrumbClick={props.onBreadcrumbClick}
        />
        {props.libraryLocked && (
          <BubbleAlert className="mb-3" variant="ocean">
            <span className="font-semibold">This template cannot be modified.</span> It may be a
            brand level event or you lack library permissions.
          </BubbleAlert>
        )}
        <ReservableExperienceTypeSelector
          experienceType={experienceType}
          modeType={props.mode.type}
          disabled={props.libraryLocked}
          onValue={nextType =>
            props.eventFormik.setFieldValue('reservables.experienceType', nextType)
          }
          autoAssignRental={props.eventFormik.values.reservables.autoAssignRental}
          onAutoAssignRental={val =>
            props.eventFormik.setFieldValue('reservables.autoAssignRental', val)
          }
        />
      </FormGenericContainer>
    </div>
  );
}
